import React from 'react'
import './BoldSectionText.css';

export default function BoldSectionText({children}) {
    return (
            <strong className='BoldSectionText'>{children}</strong>
    )
}